import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid-premium';
import { uniqueId } from 'lodash';
import { orderLineService } from 'services/api';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { OrderDetailColumns } from 'components/common/enhanced/common-headers/order-detail';

type OrderLinesStatusGridProps = {
  statusFilter: string;
  orderRef?: string | null;
};

export function OrderLinesStatusGrid({ statusFilter, orderRef }: OrderLinesStatusGridProps) {
  const columns: GridColDef[] = OrderDetailColumns();

  const { initialFilterItems, initialParams } = useMemo(() => {
    const filters = [
      {
        id: uniqueId(),
        columnField: 'status',
        operatorValue: 'is',
        value: statusFilter
      }
    ];
    const params: Record<string, string> = {
      status: statusFilter,
      is_periodic: 'false'
    };

    if (orderRef) {
      filters.push({
        id: uniqueId(),
        columnField: 'ref',
        operatorValue: 'equals',
        value: orderRef
      });
      params.ref = orderRef;
    }

    return { initialFilterItems: filters, initialParams: params };
  }, [statusFilter, orderRef]);

  return (
    <EnhancedDataGrid
      columns={columns}
      service={orderLineService}
      initialFilterItems={initialFilterItems}
      initialParams={initialParams}
    />
  );
}

export default OrderLinesStatusGrid;
